import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import TournamentsPage from "./pages/TournamentsPage";
import TournamentDetailPage from "./pages/TournamentDetailPage";
import TalentDiscoveryPage from "./pages/TalentDiscoveryPage";
import LeaderboardsPage from "./pages/LeaderboardsPage";
import AIPredictionsPage from "./pages/AIPredictionsPage";
import AthleteProfilePage from "./pages/AthleteProfilePage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminRegisterPage from "./pages/AdminRegisterPage";
import SportDetailPage from "./pages/SportDetailPage";
import CartPage from "./pages/CartPage";
import LiveMatchesPage from "./pages/LiveMatchesPage";
import TournamentBracketPage from "./pages/TournamentBracketPage";
import VerificationPage from "./pages/VerificationPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import SchoolLeaderboardPage from "./pages/SchoolLeaderboardPage";
import VideoAnalysisPage from "./pages/VideoAnalysisPage";
import VideoAnalysisDetailPage from "./pages/VideoAnalysisDetailPage";
import BiomechanicsPage from "./pages/BiomechanicsPage";
import ScoutingPortalPage from "./pages/ScoutingPortalPage";
import LiveScoresPage from "./pages/LiveScoresPage";
import MarketplacePage from "./pages/MarketplacePage";
import RankingsPage from "./pages/RankingsPage";
import SponsorshipPortal from "./pages/SponsorshipPortal";
import PlatformDemoPage from "./pages/PlatformDemoPage";
import LiveMatchConsolePage from "./pages/LiveMatchConsolePage";
import LiveWatchPage from "./pages/LiveWatchPage";
import SampleReportPage from "./pages/SampleReportPage";
import NotificationsPage from "./pages/NotificationsPage";
import InvestorPitchPage from "./pages/InvestorPitchPage";

function App() {
    return (
        <AuthProvider>
            <div className="App min-h-screen bg-background">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/auth" element={<AuthPage />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/login" element={<AdminLoginPage />} />
                        <Route path="/admin/register" element={<AdminRegisterPage />} />
                        <Route path="/tournaments" element={<TournamentsPage />} />
                        <Route path="/tournaments/:id" element={<TournamentDetailPage />} />
                        <Route path="/tournaments/:tournamentId/bracket" element={<TournamentBracketPage />} />
                        <Route path="/talent" element={<TalentDiscoveryPage />} />
                        <Route path="/leaderboards" element={<LeaderboardsPage />} />
                        <Route path="/ai-predictions" element={<AIPredictionsPage />} />
                        <Route path="/athletes/:id" element={<AthleteProfilePage />} />
                        <Route path="/profile" element={<AthleteProfilePage />} />
                        <Route path="/verification" element={<VerificationPage />} />
                        <Route path="/sports/:sportName" element={<SportDetailPage />} />
                        <Route path="/cart" element={<CartPage />} />
                        <Route path="/live" element={<LiveMatchesPage />} />
                        <Route path="/live-scores" element={<LiveScoresPage />} />
                        <Route path="/marketplace" element={<MarketplacePage />} />
                        <Route path="/payment/success" element={<PaymentSuccessPage />} />
                        <Route path="/schools/leaderboard" element={<SchoolLeaderboardPage />} />
                        <Route path="/video-analysis" element={<VideoAnalysisPage />} />
                        <Route path="/video-analysis/:videoId" element={<VideoAnalysisDetailPage />} />
                        <Route path="/video-analysis/:videoId/biomechanics" element={<BiomechanicsPage />} />
                        <Route path="/scouting" element={<ScoutingPortalPage />} />
                        <Route path="/rankings" element={<RankingsPage />} />
                        <Route path="/sponsorship" element={<SponsorshipPortal />} />
                        <Route path="/how-it-works" element={<PlatformDemoPage />} />
                        <Route path="/demo" element={<PlatformDemoPage />} />
                        <Route path="/demo/sample-report" element={<SampleReportPage />} />
                        <Route path="/live-console" element={<LiveMatchConsolePage />} />
                        <Route path="/live-console/:matchId" element={<LiveMatchConsolePage />} />
                        <Route path="/live-watch/:matchId" element={<LiveWatchPage />} />
                        <Route path="/live-watch" element={<LiveWatchPage />} />
                        <Route path="/notifications" element={<NotificationsPage />} />
                        <Route path="/invest" element={<InvestorPitchPage />} />
                        <Route path="/pitch" element={<InvestorPitchPage />} />
                        <Route path="/investor" element={<InvestorPitchPage />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" />
            </div>
        </AuthProvider>
    );
}

export default App;
